import { z } from 'zod';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from './PartialStrictObjectSchema.ts';
import { PlayerColor } from './PlayerState.ts';
import { validateState } from './ValidateState.ts';
export var TurnState = /*#__PURE__*/ function(TurnState) {
    TurnState[TurnState["InitialPlacement"] = 0] = "InitialPlacement";
    TurnState[TurnState["Dice"] = 1] = "Dice";
    TurnState[TurnState["Turn"] = 2] = "Turn";
    TurnState[TurnState["GameEnd"] = 3] = "GameEnd";
    TurnState[TurnState["SpecialBuildPhase"] = 4] = "SpecialBuildPhase";
    return TurnState;
}({});
export var ActionState = /*#__PURE__*/ function(ActionState) {
    ActionState[ActionState["None"] = 0] = "None";
    ActionState[ActionState["InitialPlacementPlaceSettlement"] = 1] = "InitialPlacementPlaceSettlement";
    ActionState[ActionState["InitialPlacementPlaceCity"] = 2] = "InitialPlacementPlaceCity";
    ActionState[ActionState["InitialPlacementRoadPlacement"] = 3] = "InitialPlacementRoadPlacement";
    ActionState[ActionState["PlaceRoad"] = 4] = "PlaceRoad";
    ActionState[ActionState["PlaceRoadForFree"] = 5] = "PlaceRoadForFree";
    ActionState[ActionState["PlaceSettlement"] = 6] = "PlaceSettlement";
    ActionState[ActionState["PlaceCity"] = 7] = "PlaceCity";
    ActionState[ActionState["PlaceCityWithDiscount"] = 8] = "PlaceCityWithDiscount";
    ActionState[ActionState["PlaceShip"] = 9] = "PlaceShip";
    ActionState[ActionState["PlaceShipForFree"] = 10] = "PlaceShipForFree";
    ActionState[ActionState["SelectShipToMove"] = 11] = "SelectShipToMove";
    ActionState[ActionState["MoveShip"] = 12] = "MoveShip";
    ActionState[ActionState["PlaceCityWall"] = 13] = "PlaceCityWall";
    ActionState[ActionState["PlaceCityWallForFree"] = 14] = "PlaceCityWallForFree";
    ActionState[ActionState["PlaceKnight"] = 15] = "PlaceKnight";
    ActionState[ActionState["PlaceKnightForFree"] = 16] = "PlaceKnightForFree";
    ActionState[ActionState["UpgradeKnight"] = 17] = "UpgradeKnight";
    ActionState[ActionState["UpgradeKnightForFree"] = 18] = "UpgradeKnightForFree";
    ActionState[ActionState["ActivateKnight"] = 19] = "ActivateKnight";
    ActionState[ActionState["SelectKnightToTakeAction"] = 20] = "SelectKnightToTakeAction";
    ActionState[ActionState["SelectKnightAction"] = 21] = "SelectKnightAction";
    ActionState[ActionState["MoveKnightOffTurn"] = 22] = "MoveKnightOffTurn";
    ActionState[ActionState["SelectKnightToRemove"] = 23] = "SelectKnightToRemove";
    ActionState[ActionState["PlaceRobberOrPirate"] = 24] = "PlaceRobberOrPirate";
    ActionState[ActionState["PlaceRobberOnly"] = 25] = "PlaceRobberOnly";
    ActionState[ActionState["PlacePirateOnly"] = 26] = "PlacePirateOnly";
    ActionState[ActionState["SelectWhoToRob"] = 27] = "SelectWhoToRob";
    ActionState[ActionState["SelectCardsToDiscard"] = 28] = "SelectCardsToDiscard";
    ActionState[ActionState["SelectProgressCardsToDiscard"] = 29] = "SelectProgressCardsToDiscard";
    ActionState[ActionState["Place2MoreRoadBuilding"] = 30] = "Place2MoreRoadBuilding";
    ActionState[ActionState["Place1MoreRoadBuilding"] = 31] = "Place1MoreRoadBuilding";
    ActionState[ActionState["Select2ResourcesForYearOfPlenty"] = 32] = "Select2ResourcesForYearOfPlenty";
    ActionState[ActionState["Select1ResourceForMonopoly"] = 33] = "Select1ResourceForMonopoly";
    ActionState[ActionState["SelectCardsForPendingDistributions"] = 34] = "SelectCardsForPendingDistributions";
    ActionState[ActionState["PlaceMetropolis"] = 35] = "PlaceMetropolis";
    ActionState[ActionState["SelectProgressCard"] = 36] = "SelectProgressCard";
    ActionState[ActionState["SelectCityToPillage"] = 37] = "SelectCityToPillage";
    ActionState[ActionState["PlaceMerchant"] = 38] = "PlaceMerchant";
    ActionState[ActionState["SelectDiceForAlchemist"] = 39] = "SelectDiceForAlchemist";
    ActionState[ActionState["SelectTileProductionNumbersToSwap"] = 40] = "SelectTileProductionNumbersToSwap";
    ActionState[ActionState["SelectPlayerForDeserter"] = 41] = "SelectPlayerForDeserter";
    ActionState[ActionState["SelectRoadToRemove"] = 42] = "SelectRoadToRemove";
    ActionState[ActionState["DiplomatSelectWhetherToPlaceNewEdgePiece"] = 43] = "DiplomatSelectWhetherToPlaceNewEdgePiece";
    ActionState[ActionState["IntrigueSelectKnightToMove"] = 44] = "IntrigueSelectKnightToMove";
    ActionState[ActionState["SpySelectPlayer"] = 45] = "SpySelectPlayer";
    ActionState[ActionState["SpySelectProgressCard"] = 46] = "SpySelectProgressCard";
    ActionState[ActionState["SelectCardsForWedding"] = 47] = "SelectCardsForWedding";
    ActionState[ActionState["CommercialHarborSelectPlayerAndResource"] = 48] = "CommercialHarborSelectPlayerAndResource";
    ActionState[ActionState["CommercialHarborOpponentSelectsCard"] = 49] = "CommercialHarborOpponentSelectsCard";
    ActionState[ActionState["MasterMerchantSelectPlayer"] = 50] = "MasterMerchantSelectPlayer";
    ActionState[ActionState["MasterMerchantSelectCards"] = 51] = "MasterMerchantSelectCards";
    ActionState[ActionState["MerchantFleetSelectResource"] = 52] = "MerchantFleetSelectResource";
    ActionState[ActionState["ResourceMonopolySelectResource"] = 53] = "ResourceMonopolySelectResource";
    ActionState[ActionState["CommodityMonopolySelectResource"] = 54] = "CommodityMonopolySelectResource";
    return ActionState;
}({});
export const currentStateSchema = z.object({
    completedTurns: z.number().int().nonnegative(),
    turnState: z.enum(TurnState),
    /**
         * @deprecated Using this field will break Colonist Rush. Use currentStateValidator.getPlayerActionState() instead
         */ actionState: z.enum(ActionState),
    /**
         * @deprecated Using this field will break Colonist Rush. Use currentStateValidator.currentTurnPlayers instead
         */ currentTurnPlayerColor: z.enum(PlayerColor),
    startTime: z.number().min(0),
    // BUG: allocatedTime can be negative in the game. Remove this comment and add .min(0) once fixed.
    allocatedTime: z.number()
}).strict();
export function validateCurrentState(data) {
    return validateState(currentStateSchema, data);
}
export const currentStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(currentStateSchema);
